import React from 'react'
import {Outlet} from 'react-router-dom'
import {useEyeconxStore} from '../../../store/eyeconxStore'
import SmsNav from './SmsNav'
import SmsSide from './SmsSide'
import './SmsSkeleton.css'
import './Sms.css'

function SmsLayout() {
    const smsSidebarCollapsed = useEyeconxStore((state) => state.smsSidebarCollapsed)

    return (
        <div className="sms-layout">
            <aside
                className={`sms-sidebar ecx-sidebar d-none d-md-block ${
                    smsSidebarCollapsed ? 'sms-sidebar--collapsed ecx-sidebar--collapsed' : ''
                }`}
                aria-label="SMS navigation"
            >
                <SmsSide collapsed={smsSidebarCollapsed}/>
            </aside>

            <main className="sms-main">
                <div className="flex-shrink-0" style={{zIndex: 1000, backgroundColor: '#fff'}}>
                    <SmsNav/>
                </div>
                <div className="sms-main-content">
                    <Outlet/>
                </div>
            </main>
        </div>
    )
}

export default SmsLayout
